<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import baseMixin from './mixin';
import { mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import { planTypes } from '@/common/constants';
import { isZoomSass } from './utils';
import { pageConfig } from '@/common/service/page-config';

export default {
  name: 'AdditionalHostAddon',
  mixins: [base, baseMixin],
  for: (args)=> {
    const [,, selectedPlans] = args;
    return isZoomSass(selectedPlans) & (
      pageConfig.editConfig.planType === planTypes.EVENT_SAAS || pageConfig.editConfig.planType === planTypes.EVENT_SAAS_CORE
    );
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return orderBy(
        filter(this.planMapFlat, (p) => p.type === planTypes.ADDITIONAL_HOST && p.isCurrentCategory),
        ['amount'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
